/**
 * Class strings shared by the steps of the manager assessment setup page.
 */

/**
 * The heading of every step, and of the page above them: 20px on a phone, 24px from 768px up.
 *
 * The two pixel values are the `text-xl` and `text-2xl` steps spelt out. Written as a `max-md:` /
 * `md:` pair rather than a base class and its own variant, because the mirror typography utilities
 * of `app.css` carry `!important` -- a base class there beats its own `md:` step.
 */
export const SETUP_STEP_TITLE = 'max-md:text-[20px] md:text-[24px] font-medium text-gray-900';
